<template>
    <div class="container">
        <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
        <form class="feedback" @submit.prevent="sendForm()">
            <p class="title">Спасибо за проведенную презентацию!</p>
            <p class="title">Цели-факты по презентации</p>
            <div class="feedback__row" v-for="(item, index) in presentationInfo.goal" :key="index">
                <p>{{item.name}}</p>
                <p>{{item.plan}}</p>
                <input type="text" v-model="item.fact" placeholder="Факт">
            </div>
            
            
            <input type="submit" :class="{blockedButton: blockButton}" value="Далее">
        </form>
    </div>

</template>
<script>
import settings from '../settings'

export default {
    data: () => ({
        collectionId: '',
        presentationId: '',
        presentationInfo: [],
        blockButton: false,
        preloader: false
      
    }),
    methods: {
        startComponent(){
            this.$store.dispatch('GET_PRESENTATION_INFO', this.presentationId).then(r => {
                this.presentationInfo = r.data.data;
            })
        },
        // Отправить комментарий
        sendForm(){
            this.blockButton = true;
            this.preloader = true;
            
            if(this.presentationInfo){
                this.$store.dispatch('UPDATE_PRESENTATION', this.presentationInfo)
                .then(r => {
                    console.log('факты презентации', r)
                    if(r.data.status == 'success'){
                        this.$makeToast(
                            "Поздравляем!",
                            "success",
                            `Информация сохранена!`
                        )
                        setTimeout(()=>{this.$router.push({name: 'comment' })}, 3000)
                    }else{
                        this.$makeToast(
                            "Упс!",
                            "danger",
                            `Что-то пошло не так`
                        )
                    }
                })
            }
        },
    },
    created(){
        let clientInfo = this.$localStorageGet('currentClientInfo');
        let presentationID = this.$localStorageGet('presentationID');
        this.collectionId = clientInfo.collectionId;
        this.presentationId = presentationID;
        this.startComponent()

        
    }
}
</script>
<style lang="scss" scoped>
    .shadow-block{
        // min-height: 100vh;
        // min-height: 600px;
        min-height: 100%;
        width: 100%;
    }
    .container{
        overflow: hidden;
        position: relative;
    }

    form, .responseLink{
        width: 100%;
        // min-height: 100vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;

        
        .title{
            font-size: 18px;
            line-height: 24px;
            display: flex;
            align-items: center;
            text-align: center;
            text-transform: uppercase;
            color: #fff;
            margin-bottom: 15px;
        }
        textarea{
            width: 100%;
            height: 175px;
            padding: 8px;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            margin-bottom: 15px;
        }
        input[type='submit'],
        .backToCatalog{
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000;
            font-size: 18px;
            text-transform: uppercase;
        }
    }
    .backToCatalog{
        margin-top: 20px;
    }
    .feedback{
        padding-top: 60px;
        height: 100%;
        flex-grow: 2;
    }
    .backToMain-btn{
        margin-top: 20px;
    }
    .signLink{
        right: -380px;
        position: absolute;
        top: 0;
        input[type='text']{
            width: 250px;
            margin-bottom: 38px;
            height: 20px;
            background: none;
            border: none;
            border-bottom: 1px solid #fff;
            padding: 5px 0px;
            color: #fff;
            font-size: 14px;
            line-height: 16px;
            outline: none;
            height: 40px;
            min-height: 40px;
        }
        input[type='submit']{
            width: 250px;
        }
        input.error{
            border: 1px solid red;
        }
    }
    .responseLink{
        padding: 15px;
        left: 0;
        position: absolute;
        display: none;
        opacity: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title{
            margin-bottom: 20px;
        }
        a{
            color: #000;
            height: 40px;
            margin-top: 50px;
            width: 250px;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
        }
        #newLink{
            color: #fff;
            background: none;
            border: none;
            outline: none;
            word-break: break-all;
            &:hover{
                cursor: pointer;
            }
        }
    }
    .input-group{
        width: 250px;
        margin-bottom: 15px;

        input{
            width: 100%;
            height: 20px;
            font-size: 12px;
            background: none;
            border: none;
            outline: none;
            color: rgba(255, 255, 255, 0.5);
            
            &:hover,
            &:focus{
                border: none;
                outline: none;
                box-shadow: none;
                background: none;
            }
            &.input-group__target{
                border-bottom: 1px solid #fff;
            }
            &.input-group__plan{
                background: rgba(196, 196, 196, 0.3);
            }
        }
    }
    .feedback__row{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        p{
            color: #fff;
            font-size: 12px;
        }
        input{
            font-size: 12px;
            background-color: rgba(196, 196, 196, 0.3);
            border: none;
            color: #fff;
            margin-top: 5px;
            padding: 0 5px;
            &:focus{
                outline: none;
            }

        }
    }
    input[type="submit"]{
        margin-top: auto;
    }
</style>